import { styled } from '@mui/material'
// oxlint-disable-next-line no-restricted-imports
import { IconCaretDownOutline18, IconCaretUpOutline18 } from 'nucleo-ui-outline-18'

// Nucleo's caret icons render as an unfilled outline stroke, but the design sheet's carets are
// solid — override the inner path's fill/stroke rather than leaving the mismatch, since a caret
// drawn as a thin outline reads poorly at the small sizes carets are used at.
const filledCaretSx = { '& path': { fill: 'currentColor', stroke: 'none' } }

export const CaretDownOMIcon = styled(IconCaretDownOutline18)(filledCaretSx)
export const CaretUpOMIcon = styled(IconCaretUpOutline18)(filledCaretSx)
